const DEFAULT_LENGTH = 30;
const DEFAULT_OMISSION = '...';

type Options = {
    length?: number;
    omission?: string;
    separator?: string | RegExp;
};

type TruncFunction = {
    (text?: string, options?: Options): string;
    (text?: string, length?: number): string;
};

export const trunc: TruncFunction = (text, options) => {
    if (!text) {
        return '';
    }

    const length = (typeof options === 'number' ? options : options?.length) ?? DEFAULT_LENGTH;
    const omission =
        typeof options !== 'number' ? (options?.omission ?? DEFAULT_OMISSION) : DEFAULT_OMISSION;
    const separator = (typeof options !== 'number' && options?.separator) || undefined;

    if (length >= text.length) {
        return text;
    }

    if (length <= omission.length) {
        return omission;
    }

    if (separator) {
        const regexp = new RegExp(separator, 'g');

        const matches = [...text.matchAll(regexp)];

        const lastMatch = matches.toReversed().find(({ index }) => {
            return index <= length - omission.length;
        });

        if (lastMatch) {
            const { index } = lastMatch;

            return `${text.slice(0, index)}${omission}`;
        }
    }

    const truncText = text.slice(0, length - omission.length);

    return `${truncText}${omission}`;
};
